module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#fig_1.1"
    }
  }, [_vm._v("1.1. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Synoptic problem hypotheses")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#fig_1.2"
    }
  }, [_vm._v("1.2. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("John and the Synoptics")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01#fig_2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Modeling Matthew’s use of a waxed tablet")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01#fig_2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Modeling collation, annotation, and composition")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01#fig_2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Feeding the Five Thousand according to Codex Fuldensis")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#fig_3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Insulting scribes and Pharisees")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#fig_3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Synopsis of Matt 9:3–4 // Mark 2:6–8 // Luke 5:21–22")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#fig_4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Jesus’s journeys according to Mark")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#fig_4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Jesus’s journeys according to John")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#fig_4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("Synopsis of Matt 18:3 and John 3:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Conclusion#fig_6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1. "), _c('span', {
    staticClass: "pad10"
  }, [_vm._v("John and the Synoptics")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd942f00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Figures.vue
// module id = 72
// module chunks = 0